import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { FranchiseState } from './franchises.slice';
import {
  createFranchiseApiKeyV1Thunk,
  createFranchiseApiKeyV2Thunk,
  generateFranchiseDailyAppsKeyThunk,
  getFranchiseApiKeyV1Thunk,
  getFranchiseApiKeyV2Thunk,
  getFranchiseDailyAppsKeyThunk,
  revokeFranchiseDailyAppsKeyThunk,
} from './franchises.thunk';

// A failed generate or revoke keeps the loaded key and leaves `hasError` to the failed load: the toast reports it.
const addApiKeyReducers = (builder: ActionReducerMapBuilder<FranchiseState>) => {
  builder.addCase(getFranchiseApiKeyV1Thunk.pending, state => {
    state.apiKey.v1 = { isLoading: true, hasError: false };
  });
  builder.addCase(getFranchiseApiKeyV1Thunk.fulfilled, (state, action) => {
    state.apiKey.v1 = { key: action.payload?.apiKey, isLoading: false, hasError: false };
  });
  builder.addCase(getFranchiseApiKeyV1Thunk.rejected, state => {
    state.apiKey.v1 = { isLoading: false, hasError: true };
  });

  builder.addCase(createFranchiseApiKeyV1Thunk.pending, state => {
    state.apiKey.v1 = { ...state.apiKey.v1, isLoading: true, hasError: false };
  });
  builder.addCase(createFranchiseApiKeyV1Thunk.fulfilled, (state, action) => {
    state.apiKey.v1 = { key: action.payload?.apiKey, isLoading: false, hasError: false };
  });
  builder.addCase(createFranchiseApiKeyV1Thunk.rejected, state => {
    state.apiKey.v1 = { ...state.apiKey.v1, isLoading: false, hasError: true };
  });

  builder.addCase(getFranchiseApiKeyV2Thunk.pending, state => {
    state.apiKey.v2 = { isLoading: true, hasError: false };
  });
  builder.addCase(getFranchiseApiKeyV2Thunk.fulfilled, (state, action) => {
    state.apiKey.v2 = { key: action.payload?.apiKey, isLoading: false, hasError: false };
  });
  builder.addCase(getFranchiseApiKeyV2Thunk.rejected, state => {
    state.apiKey.v2 = { isLoading: false, hasError: true };
  });

  builder.addCase(createFranchiseApiKeyV2Thunk.pending, state => {
    state.apiKey.v2 = { ...state.apiKey.v2, isLoading: true, hasError: false };
  });
  builder.addCase(createFranchiseApiKeyV2Thunk.fulfilled, (state, action) => {
    state.apiKey.v2 = { key: action.payload?.apiKey, isLoading: false, hasError: false };
  });
  builder.addCase(createFranchiseApiKeyV2Thunk.rejected, state => {
    state.apiKey.v2 = { ...state.apiKey.v2, isLoading: false, hasError: true };
  });

  builder.addCase(getFranchiseDailyAppsKeyThunk.pending, state => {
    state.apiKey.dailyapps = { isLoading: true, hasError: false };
  });
  builder.addCase(getFranchiseDailyAppsKeyThunk.fulfilled, (state, action) => {
    state.apiKey.dailyapps = { key: action.payload?.apiKey, isLoading: false, hasError: false };
  });
  builder.addCase(getFranchiseDailyAppsKeyThunk.rejected, state => {
    state.apiKey.dailyapps = { isLoading: false, hasError: true };
  });

  builder.addCase(generateFranchiseDailyAppsKeyThunk.pending, state => {
    state.apiKey.dailyapps = { ...state.apiKey.dailyapps, isLoading: true, hasError: false };
  });
  builder.addCase(generateFranchiseDailyAppsKeyThunk.fulfilled, (state, action) => {
    state.apiKey.dailyapps = { key: action.payload?.apiKey, isLoading: false, hasError: false };
  });
  builder.addCase(generateFranchiseDailyAppsKeyThunk.rejected, state => {
    state.apiKey.dailyapps = { ...state.apiKey.dailyapps, isLoading: false };
  });

  builder.addCase(revokeFranchiseDailyAppsKeyThunk.pending, state => {
    state.apiKey.dailyapps = { ...state.apiKey.dailyapps, isLoading: true, hasError: false };
  });
  builder.addCase(revokeFranchiseDailyAppsKeyThunk.fulfilled, state => {
    state.apiKey.dailyapps = { isLoading: false, hasError: false };
  });
  builder.addCase(revokeFranchiseDailyAppsKeyThunk.rejected, state => {
    state.apiKey.dailyapps = { ...state.apiKey.dailyapps, isLoading: false };
  });
};

export default addApiKeyReducers;
